var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.glFeatures.repositoryLockInformation && _vm.isLocked)?_c('gl-button',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],attrs:{"title":_vm.lockIconTooltip,"aria-label":_vm.lockIconTooltip,"category":"tertiary","variant":"default","icon":"lock"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }